export default "__VITE_ASSET__C$mu65O7__"